import { render, staticRenderFns } from "./beneficiary-chart.vue?vue&type=template&id=2126b53b&"
import script from "./beneficiary-chart.vue?vue&type=script&lang=js&"
export * from "./beneficiary-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2126b53b')) {
      api.createRecord('2126b53b', component.options)
    } else {
      api.reload('2126b53b', component.options)
    }
    module.hot.accept("./beneficiary-chart.vue?vue&type=template&id=2126b53b&", function () {
      api.rerender('2126b53b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/beneficiary-chart.vue"
export default component.exports